import createRule from './rule.service';

export default function validateRule(ruleText, attribute = '') {
  const rule = createRule(ruleText, attribute);
  return rule.getRuleType() !== 'UNSPECIFIED' && rule.validate();
}
